import React from 'react'; // Cleaned up imports
import { useAlert } from '../../context/AlertContext';
import './GlobalAlert.css';

const GlobalAlert = () => {
    const { alert, hideAlert } = useAlert();

    if (!alert.show) {
        return null;
    }

    const getAlertClass = (type) => {
        switch (type) {
            case 'success': return 'alert-success';
            case 'error': return 'alert-danger'; // Bootstrap uses alert-danger for errors
            case 'warning': return 'alert-warning';
            case 'info':
            default: return 'alert-info';
        }
    };

    return (
        <div className={`global-alert-container`}>
            <div className={`alert ${getAlertClass(alert.type)} alert-dismissible fade show`} role="alert">
                <span className="global-alert-message">{alert.message}</span>
                <button type="button" className="btn-close global-alert-close" aria-label="Close" onClick={hideAlert}></button>
            </div>
        </div>
    );
};

export default GlobalAlert;
